"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.styles = void 0;

var _react = require("@emotion/react");

var _util = require("../../../util");

function _EMOTION_STRINGIFIED_CSS_ERROR__() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }

var imgBox = function imgBox(theme) {
  return /*#__PURE__*/(0, _react.css)("width:", (0, _util.rem)(40), ";height:", (0, _util.rem)(40), ";background-color:", theme.color.monochrome.light, ";border-radius:4px;overflow:hidden;display:flex;align-items:center;justify-content:center;color:", theme.color.monochrome.mediumDark, ";img{width:100%;height:100%;}svg{width:18px;height:18px;}" + (process.env.NODE_ENV === "production" ? "" : ";label:imgBox;"));
};

var link = process.env.NODE_ENV === "production" ? {
  name: "4hk5dw",
  styles: "svg{width:16px;height:16px;vertical-align:text-bottom;}"
} : {
  name: "pmvnlg-link",
  styles: "svg{width:16px;height:16px;vertical-align:text-bottom;};label:link;",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__
};
var styles = {
  imgBox: imgBox,
  link: link
};
exports.styles = styles;
//# sourceMappingURL=Product.styles.js.map